// extracted by mini-css-extract-plugin
export default {"free_delivery":"FreeDelivery_free_delivery__dIg2b","header":"FreeDelivery_header__n2-aB","cover":"FreeDelivery_cover__qfTDX","submit":"FreeDelivery_submit__qIyna"};